import { useEffect, useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import { connectWallet, getCurrentWalletConnected, mintNFT } from "./utils/interact.js";
import { Container, Grid } from "@material-ui/core";
import { times } from "lodash";
<meta>
<header>EdDrop: Education For NFTs</header>
<link rel="favicon" src= "%PUBLIC_URL%/favicon.png"></link>

</meta>

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  size: {
    height: 30,
    width: 110,
  },
  appBar: {
    width: `calc(100% - 0px)`,
    height: "10%",
    marginLeft: drawerWidth,
    background:
      "linear-gradient(90deg, rgba(255, 255, 255, 1) 81%, rgba(255, 235, 59, 1) 100%)",
    color: "inherit",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  pageLinks: {
    marginLeft: "70%",
    //marginTop:100
  },

// quantityButtons: {
//   padding: "25px",
// },

  customInput: {
    color: "#3c3c3c",
    border: "1px solid #dfdfdf",
    borderRadius: "10px",
    padding: "5px 15px",
    transition: "all 0.3s ease-in-out",
    "&:focus": {
      border: "1px solid gold",
    },
    resize: "none",
    width: "100%",
    fontFamily: "Rubik",
    fontSize: "16px",
    outline: "none",
  },
  customLabel: {
    padding: "20px 0px 10px 0px",
    display: "inline-block",
    color: "gold",
    width: "100%",
    textAlign: "left",
    fontWeight: "600"
  },
  outerBox: {
    width: "90%",
  },
  polyTest: {
    color: "Gold",
    fontSize: "18px",
    

  },
  quantLabel: {
    padding: "20px 0px 10px 0px",
    display: "inline-block",
    color: "gold",
    width: "100%",
    textAlign: "center",
    fontWeight: "600"
  },
  // myText: {
  //   fontFace: "monospace: Courier",
  // },
  // myUpload: {
  //   border: "20px solid black",
  //   borderRadius: "10px",
  // },
  // myButton: {
  //   color: "Yellow",
  //   border: "1px solid black",
  //   borderRadius: "10px",
  //   paddingTop: "15%"
  // },
  // myPad: {
  //   paddingBottom: "15px",
  //   fontFace: "monospace: Courier",
  // },
  // myBox: {
  //  width: "4rem, 6rem",
  //  padding:"10px",
  //  background:"#ccc",
  //  border:"2px solid #666",
  //  boxShadow: "2rem 2rem 2rem #999",
  // },

  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 0,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
  },
}));

const Minter = (props) => {
  //State variables
  const [isConnected, setConnectedStatus] = useState(false);
  const [walletAddress, setWallet] = useState("");
  const [status, setStatus] = useState("");
  const [name, setName] = useState("");
  const [instructor, setInstructor] = useState("");
  //  const [url, setURL] = useState("");
  const [platform, setPlatform] = useState("");
  const [description, setDescription] = useState("");
  const [dates, setDates] = useState("");
  const [content, setContent] = useState("");
  const [skills, setSkills] = useState("");
  const [roster, setRoster] = useState("");
  const [external_url, setExternal_URL] = useState("");
  const [score, setScore] = useState("");
  const [image, setImage] = useState("");
  const [quantity, setQuantity] = useState("1");


  useEffect(async () => {
    //TODO: implement
  });

  const connectWalletPressed = async () => {
    const walletResponse = await connectWallet();
    setStatus(walletResponse.status);
    setWallet(walletResponse.address);
  };
  const onMintPressed = async () => {
    //TODO: implement

    const quantityAsNumber = +quantity
    for (let i=1; i < quantity; ++i) {
      await mintNFT(
        name,
        instructor,
        platform,
        description,
        dates,
        content,
        skills,
        roster,
        external_url,
        score,
        image,
      );
    }
    const { status } = await mintNFT(
      name,
      instructor,
      platform,
      description,
      dates,
      content,
      skills,
      roster,
      external_url,
      score,
      image,
    );
    setStatus(status);
  };


  //const  mintTestPress = async () => {
  //   console.log(name)
  //   console.log(genre)
  //   console.log(waveform)
  //  console.log(artwork)
  //   console.log(artist)
  // }
  const onRedirect = async () => {
    window.location.href= "https://eddrop.io/#transfer"
  }

  useEffect(async () => {
    if (window.ethereum) {
      //if Metamask installed
      try {
        const accounts = await window.ethereum.request({
          method: "eth_accounts",
        }); //get Metamask wallet
        if (accounts.length) {
          //if a Metamask account is connected
          setConnectedStatus(true);
          setWallet(accounts[0]);
        } else {
          setConnectedStatus(false);
          setStatus("🦊 Connect to Metamask using the top right button.");
        }
      } catch {
        setConnectedStatus(false);
        setStatus(
          "🦊 Connect to Metamask using the top right button. " + walletAddress
        );
      }
    }
  });

  const classes = useStyles();

  return (
    <>
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <Typography variant="h6" noWrap>
            EdDrop
          </Typography>
          <Breadcrumbs aria-label="breadcrumb" className={classes.pageLinks}>
            <Link href="https://eddrop-dapp.netlify.app/">
              Upload File
            </Link>
            <Typography color="textPrimary">Mint Token</Typography>
          </Breadcrumbs>
        </Toolbar>
      </AppBar>
      <br />
      <br />
      <br />



      <br />
      <br />
      <Container maxWidth="md">
        <button id="walletButton" onClick={connectWalletPressed}>
          {isConnected ? (
            "👛 Connected: " +
            String(walletAddress).substring(0, 6) +
            "..." +
            String(walletAddress).substring(38)
          ) : (
            <span>👛 Connect Wallet</span>
          )}
        </button>

        <br></br>
        <section className={classes.myBox}>
          <h1 id="title">NFTs for Education </h1>
          <p>
            Simply add your course information, upload your file, then press
            "Mint."
            <br />
           <p className={classes.polyTest}>Make sure you are connected to Polygon, or Polygon TestNet.</p>
            Scroll to bottom for help.
          </p>
          <form>
            <Grid container>
              <Grid item xs={12} md={6}>
                <div className={classes.outerBox}>
                  {/* Firebase Url */}
                  <label className={classes.customLabel}>Link From "Upload File" </label>
                  <input
                    className={classes.customInput}
                    type="text"
                    placeholder="Link From Upload File Page (Optional)"
                    onChange={(event) => setImage(event.target.value)}
                  />
                  {/* Course Name */}
                  <label className={classes.customLabel}>Course Name*</label>
                  <input
                    required="true"
                    className={classes.customInput}
                    type="text"
                    placeholder="Philosophy 101, Pomp's Crypto Course, etc.."
                    onChange={(event) => setName(event.target.value)}
                  />
                  {/* Location or platform */}
                  <label className={classes.customLabel}>
                    Location or platform*
                  </label>
                  <input
                    required="true"
                    className={classes.customInput}
                    type="text"
                    placeholder="UCLA, Maven, Springfield Elementary etc.."
                    onChange={(event) => setPlatform(event.target.value)}
                  />
                  {/* Terms or Course Dates */}
                  <label className={classes.customLabel}>
                    Terms or Course Dates*
                  </label>
                  <input
                    required="true"
                    className={classes.customInput}
                    type="text"
                    placeholder="Fall 2022; Nov. 1, 2021 - May 1, 2022"
                    onChange={(event) => setDates(event.target.value)}
                  />
                  {/* Course content */}
                  <label className={classes.customLabel}>Course content </label>
                  <input
                    className={classes.customInput}
                    type="text"
                    placeholder="List major Readings, Subjects and Topics covered (Optional)"
                    onChange={(event) => setContent(event.target.value)}
                  />
                  {/* URL */}
                  <label className={classes.customLabel}>URL </label>
                  <input
                    className={classes.customInput}
                    type="text"
                    placeholder="Link to course, syllabus, or teacher website (Optional)"
                    onChange={(event) => setExternal_URL(event.target.value)}
                  />
                  {/* Effectiveness Score */}
                  <label className={classes.customLabel}>
                    Effectiveness Score{" "}
                  </label>
                  <input
                    className={classes.customInput}
                    type="text"
                    placeholder="For student to teacher ONLY (Optional)"
                    onChange={(event) => setScore(event.target.value)}
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className={classes.outerBox}>
                  {/* Instructor Name(s) */}
                  <label className={classes.customLabel}>
                    Instructor Name(s)*
                  </label>
                  <input
                    required="true"
                    className={classes.customInput}
                    type="text"
                    placeholder="Ms. Smith, Prof. X"
                    onChange={(event) => setInstructor(event.target.value)}
                  />

                  <label className={classes.customLabel}>
                    Basic Course/Class Description*
                  </label>
                  <br />
                  {/* catalog description */}
                  <textarea
                    required="true"
                    className={classes.customInput}
                    type="text"
                    cols={50}
                    rows={10}
                    placeholder="Brief Summary of course/class or catalog description"
                    onChange={(event) => setDescription(event.target.value)}
                  ></textarea>
                  <br />
                  {/* Skills Assessed */}
                  <label className={classes.customLabel}>
                    Actual Deliverables or Skills Assessed{" "}
                  </label>
                  <input
                    className={classes.customInput}
                    type="text"
                    placeholder="Qualitative Research Essay, Balance sheets, etc.. (Optional)"
                    onChange={(event) => setSkills(event.target.value)}
                  />

                  {/* Student Roster */}
                  <label className={classes.customLabel}>Student Roster </label>
                  <input
                    className={classes.customInput}
                    type="text"
                    placeholder="Paste names of students completing course (Optional)"
                    onChange={(event) => setRoster(event.target.value)}
                  />
                  {/* Quantity */}
                  <label className={classes.customLabel}>Quantity </label>
                  <input
                    className={classes.customInput}
                    type="number"
                    min={1}
                    max={100}
                    placeholder="1-100"
                    onChange={(event) => setQuantity(event.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
          </form>
          <br />
             <br />
          <button className={classes.myButton} onClick={onMintPressed}>
            Mint NFT
          </button>
        </section>
          <button type="button" onClick={onRedirect}>
            Go to transfer
          </button>
        <p id="status">{status}</p>


        <br />
        <h4> Connecting to Polygon Main and Test net.</h4>
        <p>You need to add the network to your metamask.
          <br />
          To add Polygon to your metamask you need to:
          <br />
          1. Click on your metamask networks
          <br />
          2. Click "Add Network"
          <br />
          3. Add this information:
          <br />
          • Network Name: Matic Mainnet
          <br />
          • New RPC URL: https://polygon-rpc.com/
          <br />
          • Chain ID: 137
          <br />
          • Symbol: MATIC
          <br />
          • Block Explorer URL: https://polygonscan.com/

          <br />
          <h4>Polygon TestNet Information:</h4>
          Network Name: Mumbai Testnet
          <br />
          New RPC URL: https://rpc-mumbai.matic.today​
          <br />
          Chain ID: 80001
          <br />
          Currency Symbol: MATIC
          <br />
          Block Explorer URL: https://mumbai.polygonscan.com/
        </p>
      </Container>
    </>
  );
};

export default Minter;
